import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

// A label around a radio or checkbox names an option: regular, and semibold once the option is selected.
const labelVariants = cva(
  "group/label flex items-center gap-2 font-semibold text-[var(--fl-color-content-default-default)] select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 has-[[data-part=radio-group-item]]:font-normal has-[[data-part=radio-group-item][data-checked]]:font-semibold has-[[data-part=checkbox]]:font-normal has-[[data-part=checkbox][data-checked]]:font-semibold",
  {
    variants: {
      /** The text size of the label. Defaults to `md`. */
      size: {
        sm: "text-ui-12",
        md: "text-ui-14",
        lg: "text-ui-16",
      },
    },
    defaultVariants: {
      size: "md",
    },
  }
)

type LabelProps = React.ComponentProps<"label"> & VariantProps<typeof labelVariants>

/**
 * The text that names a form control. Point it at the control with `htmlFor`, or wrap the control in it. A label around
 * a `Checkbox` or a radio shows its text regular, and semibold once the option is checked. Inside a `Field` use
 * `FieldLabel` instead. `size` is the text size.
 */
const Label = React.forwardRef<HTMLLabelElement, LabelProps>(({ className, size, ...props }, ref) => (
  <label ref={ref} data-part="label" className={cn(labelVariants({ size }), className)} {...props} />
))

Label.displayName = "Label"

export { Label, labelVariants }
export type { LabelProps }
